import React from 'react'
import styled from 'styled-components'
import TextInput from '@components/Form/TextInput'
import TextAreaInput from '@components/Form/TextAreaInput'
import { useButtonWidth } from '@services/layout'
import {
    PageSubTitle,
    FormWrapper,
    FormRow,
    SubmitBtn,
    GrayWrapper,
} from '@appearance/styled'

export default ({
    show,
    newAppConfig,
    setNewAppConfigProp,
    openSaveConfigsModal,
}) => {
    const buttonWidth = useButtonWidth()
    if (!show) {
        return null
    }

    return (
        <GrayWrapper>
            <PageSubTitle>הגדרות כלליות</PageSubTitle>
            <FormWrapper>
                <FormRow>
                    <TextInput
                        text={
                            newAppConfig
                                ? newAppConfig.application_expiration_period
                                : ''
                        }
                        type={'number'}
                        label={'משך זמן שמירת שיר/ריקוד (חודשים)'}
                        onChangeText={(application_expiration_period) =>
                            setNewAppConfigProp({
                                application_expiration_period,
                            })
                        }
                        min={0}
                        width={buttonWidth}
                    />
                </FormRow>
                <FormRow>
                    <TextAreaInput
                        label={
                            'ברוכים הבאים למערכת רישום הריקודים של ארגון המדריכים והיוצרים!'
                        }
                        text={newAppConfig ? newAppConfig.welcome : ''}
                        onChangeText={(welcome) =>
                            setNewAppConfigProp({
                                welcome,
                            })
                        }
                        minHeight="100px"
                    />
                </FormRow>
                <FormRow>
                    <TextAreaInput
                        label={'אז איך זה עובד?'}
                        text={newAppConfig ? newAppConfig.terms_of_use : ''}
                        onChangeText={(terms_of_use) =>
                            setNewAppConfigProp({
                                terms_of_use,
                            })
                        }
                        minHeight="100px"
                    />
                </FormRow>

                <FormRow>
                    <TextAreaInput
                        label={'יש 3 שלבים לריקוד'}
                        text={newAppConfig ? newAppConfig.explanations : ''}
                        onChangeText={(explanations) =>
                            setNewAppConfigProp({
                                explanations,
                            })
                        }
                        minHeight="100px"
                    />
                </FormRow>
                <SubmitBtnContiner justifyContent={'center'}>
                    <SubmitBtn onClick={openSaveConfigsModal}>שמירה</SubmitBtn>
                </SubmitBtnContiner>
            </FormWrapper>
        </GrayWrapper>
    )
}

const SubmitBtnContiner = styled(FormRow)`
    justify-content: center;
    margin: 32px 0 20px;
`
